$(document).ready(function(){
  $(".site-header__search").click(function(){
    $(".top_bar_search").toggle();
  });

  $(".search-header_close").click(function(){
    $(".top_bar_search").toggle();
  });
if ($(window).width() < 750) {
  $(document).on("click", function () {
    $(".top_bar_search").hide();
  });
}
  $(".site-header__search, .search-header_close, .top_bar_search").on("click", function (event) {
    event.stopPropagation();
  });  
 
});


$(".site-header__menu").click(function(){
    $(this).toggleClass('icon-menu-open');
    $(".mobile-nav-wrapper").toggleClass('mobile-nav-wrapper-open');

    $(".mobile-nav-wrapper").removeClass('sub-nav--is-open');
    $(".mobile-nav-wrapper").removeClass('third-nav--is-open');
    $(".js-toggle-submenu").removeClass('is-active');
  
  
});

$(".toggle_btn").click(function () {
  $(this).toggleClass("active-desn");
  $(".header-collection-description").toggleClass("active-desn");

  if ($(".toggle_btn").hasClass("active-desn")) {
    $(".toggle_btn").text("Read Less");
  } else {
    $(".toggle_btn").text("Read More");
  }
});

$(".toggle_btnpp").click(function () {
  $(this).toggleClass("active-desn", 300);
  $(".tab-pane-prd-descriptio").toggleClass("active-desn", 300);

   $(".tab-panel-prd.accordion-header-content.active").toggleClass("removebefore");

  

  if ($(".toggle_btnpp").hasClass("active-desn")) {
    $(".toggle_btnpp").text("Read Less");
  } else {
    $(".toggle_btnpp").text("Read More");
  }
});



//   new goliath slider
  $(() => {
    const init = {
      infinite: true,
      arrows:false,
      dots:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:true
    };
    
  const win = $(window);
  const slider = $(".new-golith-img-column");

  win.on("load resize", () => {
    if (win.width() < 767) {
      slider.not(".slick-initialized").slick(init);
    } else if (slider.hasClass("slick-initialized")) {
      slider.slick("unslick");
    }
  });
});
  
  $(() => {
    const init_2 = {
      infinite: true,
      arrows:false,
      dots:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:true
    };
    
  const win_2 = $(window);
  const slider_2 = $("div#shopify-section-new-golith-icon-column .grid");

  win_2.on("load resize", () => {
    if (win_2.width() < 767) {
      slider_2.not(".slick-initialized").slick(init_2);
    } else if (slider_2.hasClass("slick-initialized")) {
      slider_2.slick("unslick");
    }
  });
});
  
   $(() => {
    const init_3 = {
      infinite: true,
      arrows:false,
      dots:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:true
    };
    
  const win_3 = $(window);
  const slider_3 = $(".ventilation-feature ul");

  win_3.on("load resize", () => {
    if (win_3.width() < 767) {
      slider_3.not(".slick-initialized").slick(init_3);
    } else if (slider_3.hasClass("slick-initialized")) {
      slider_3.slick("unslick");
    }
  });
});


 $(() => {
    const init_3 = {
      infinite: true,
      arrows:false,
      dots:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay:true
    };
    
  const win_3 = $(window);
  const slider_3 = $(".ingredient_list_all");

  win_3.on("load resize", () => {
    if (win_3.width() < 749) {
      slider_3.not(".slick-initialized").slick(init_3);
    } else if (slider_3.hasClass("slick-initialized")) {
      slider_3.slick("unslick");
    }
  });
});


   $('.testimonial-section-main-inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    appendArrows: '.slick-arrow-class',
     responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });
  
  $('.product-info-slide-main-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
     responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1
      }
    }
  ]
  });



$(document).ready(function(){

$(".site-nav__link--main").click(function(){
   $('.site-nav__link--main.checked').not(this).removeClass('checked');
    $(this).toggleClass('checked');
 
  
if($(this).hasClass('checked')){
  $('.main-content').addClass('brulery');
} else{
  $('.main-content').removeClass('brulery');
}
}) 


  $('body').click(function() {
  $('.site-nav__link--main').removeClass('checked');
   $('.main-content').removeClass('brulery'); 
});

$('.mega-collections').click(function(event){
   event.stopPropagation();
});


  
  });




// pay buttons js

$(document).ready(function(){
    $('.close_afterpay').click(function(){
        $('#afterpay-popup-wrapper').hide();
    });
    $('.afterpay-link').click(function(){
        $('#afterpay-popup-wrapper').css('display', 'block');
    });
});
    
$('.laybuy-link').click(function(){
	$('#laybuy-popup-wrapper').show();
});




if ($(window).width() < 750) {
$('.multi-services-inner').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 5000,
});

$('.collection_tab_section_start ul.tabs-nav').slick({
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 5000,
});  
  
}

$('.slider-team-content').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1
      }
    }
  ]
});




$(document).ready(function() {
  $(".tab-headers-prd li").click(function() {
    var tabIndex = $(this).index();
    
    $(".tab-headers-prd li").removeClass("active");
    $(this).addClass("active");
    
    $(".tab-panel-prd").removeClass("active");
    $(".tab-panel-prd").eq(tabIndex).addClass("active");
  });
});

$(document).ready(function() {
  $(".accordion-header").click(function() {
    $(this).toggleClass("active");
    $(this).next(".tab-panel-prd").slideToggle();
    $(".accordion-header").not(this).removeClass("active");
    $(".tab-panel-prd").not($(this).next()).hide();     
  });
});


$(document).ready(function() {
if ($(window).width() < 990) {  
$('.review_text').click(function(){
  $(".accordion-header-review-title").addClass("active");
  $(".accordion-header-review-contant").show();
  $(".accordion-header-descriptio").removeClass("active");
  $(".accordion-header-specs").removeClass("active");
  $(".accordion-header-content").hide();
  $(".accordion-header-spec").hide();
   $(".accordion-header-spec").removeClass("active");
  $(".accordion-header-content").removeClass("active");
});
} 
});

$(document).ready(function() {
if ($(window).width() < 750) {  
//$(".template-product .breadcrumbs_main").insertBefore(".product-single__meta");  
} 
});


$(document).ready(function() {
if ($(window).width() < 990) {  
$(".accordion-header-review-title").insertBefore(".accordion-header-descriptio");
$(".accordion-header-review-contant").insertBefore(".accordion-header-descriptio"); 
$(".accordion-header-descriptio").insertAfter(".accordion-header-specs"); 
$(".accordion-header-content").insertAfter(".accordion-header-descriptio");
$(".accordion-header-spec").insertAfter(".accordion-header-specs");
$("#shopify-section-product-details").remove();  
} 
});


$(document).ready(function() {
if ($(window).width() > 989) {  
  $(".desktop-product-page-review").appendTo(".review_with_inner");
  $(".mobile-video-section-tab .video_class").appendTo(".video_with_inner");  

    $(".desktop-product-page-review").appendTo(".review_with_inner");
  $(".mobile-video-section-tab .video_class").appendTo(".video_with_inner");  
} 
});

document.addEventListener("DOMContentLoaded", function() {
            const originalDiv = document.querySelector(".jdgm-prev-badge__text");
            const targetDiv = document.querySelector(".review-count");

            // Add a class to targetDiv when originalDiv contains the "added-class" class
             if (originalDiv.textContent.trim() === "No reviews") {
                targetDiv.classList.remove("review_with_video");
            }
    });

document.addEventListener("DOMContentLoaded", function() {
            const originalDiv = document.querySelector(".jdgm-prev-badge__text");
            const targetDiv = document.querySelector(".review_text");
           const removeDiv = document.querySelector(".review_star_text");
  

            // Add a class to targetDiv when originalDiv contains the "added-class" class
             if (originalDiv.textContent.trim() === "No reviews") {
                    removeDiv.remove();

            }
             else{
               targetDiv.textContent = "Click here to read reviews";
            }
    });


$('.home-top-slider-inner').slick({
  dots: true,
  arrows:false,
  infinite: true,
  speed: 800,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover:false,
  slidesToShow: 1,
});

